// @flow

// Libs
import React from 'react'

// Messages
import { FormattedMessage } from 'react-intl'
import messages from 'hfty-datatable-soil-jobs/src/messages'

// Constants
import {
  SMALL_SIZE,
  MEDIUM_SIZE,
  LARGE_SIZE,
  SORT_AS_NUMBER,
  SORT_AS_DATE,
  SORT_AS_MIX,
  SORT_AS_BOOLEAN,
} from 'fc-component-datatable'
import {
  ATTR_SOIL_JOB_ID,
  ATTR_CREATED_DATE,
  ATTR_SEASON,
  ATTR_FARM,
  ATTR_FIELD,
  ATTR_GRID_SIZE,
  ATTR_AREA,
  ATTR_PRICE,
  ATTR_STATUS,
  ATTR_MAP_VIEW,
  ATTR_HAS_MAP_VIEW,
  ATTR_LAB_RESULTS,
  ATTR_HAS_LAB_RESULTS,
  ATTR_COMMENTS,
  ATTR_HAS_COMMENTS,
  ATTR_RECOMMENDATIONS,
  ATTR_HAS_RECOMMENDATIONS,
  ATTR_REOPEN_JOB,
  ATTR_HAS_REOPEN_JOB_BTN,
} from 'hfty-datatable-soil-jobs/src/constants'

// Translate util
const translate = (column: Object): React.Element<any> => <FormattedMessage {...messages[column.attr]} />

// Columns config
export default [
  {
    attr: ATTR_SOIL_JOB_ID,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_CREATED_DATE,
    size: MEDIUM_SIZE,
    render: translate,
    sortAs: SORT_AS_DATE,
  },
  {
    attr: ATTR_SEASON,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_FARM,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_FIELD,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_GRID_SIZE,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_MIX,
  },
  {
    attr: ATTR_AREA,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_PRICE,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_MIX,
  },
  {
    attr: ATTR_STATUS,
    size: MEDIUM_SIZE,
    render: translate,
  },
  {
    attr: ATTR_MAP_VIEW,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_MAP_VIEW,
  },
  {
    attr: ATTR_LAB_RESULTS,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_LAB_RESULTS,
  },
  {
    attr: ATTR_COMMENTS,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_COMMENTS,
  },
  {
    attr: ATTR_RECOMMENDATIONS,
    size: MEDIUM_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_RECOMMENDATIONS,
  },
  {
    attr: ATTR_REOPEN_JOB,
    size: MEDIUM_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_REOPEN_JOB_BTN,
  },
]
